import React, { useCallback, useContext, useEffect, useState } from 'react'
import { getHomeWorks } from './api/getHomeWorks';
import { Preloader } from '../../components/Preloader';
import { HomeWorkTable } from './components/HomeWorkTable/HomeWorkTable';
import { sendPageViewEvent } from '../../utils/utils';
import { AppContext } from '../../AppContext';
import './HomeWork.scss';
import './styles/dark.scss';

const accessMap = {
  free: ['free'],
  Standard: ['free', 'pc'],
  Premium: ['free', 'pc', 'pcp']
};

function filterAvailable(userType, row) {
  return accessMap[userType].includes(row.access);
}

export function HomeWork() {
  const { user } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const [state, setState] = useState(null);

  const init = useCallback(async () => {
    try {
      setIsLoading(true);
      setState(null);

      const data = await getHomeWorks();

      setState({
        available: data.filter((row) => filterAvailable(user.type, row)),
        notAvailable: user.type !== 'Premium' ? data.filter((row) => !filterAvailable(user.type, row)) : null
      });
      setIsLoading(false);
    } catch(e) {}
  }, [user]);

  useEffect(() => {
    const element = document.querySelector("[data-screen='homework']");
    const pageTitle = element?.getAttribute("data-pagetitle") || 'Homeworks – PokerCoaching.com';
    
    document.title = pageTitle;

    sendPageViewEvent('Homeworks | PokerCoaching.com');
    init();
  }, [init]);

  return (
    <div className="HomeWorks">
      {isLoading ? (
        <Preloader className="HomeWorks__preloader" />
      ) : (
        <>
          <h1 className="HomeWorks__title">Homework</h1>
          <HomeWorkTable data={state.available} />
          {user.type !== 'Premium' && (
            <>
              <h1 className="HomeWorks__sub-title">The homework assignments below are available to paying PokerCoaching.com members.</h1>
              <HomeWorkTable disabled data={state.notAvailable} />
            </>
          )}
        </>
      )}
    </div>
  )
}
